import { React } from "react";

const Card = ({likes,image,comment}) => {
  return (
    <div className="items">
      <img src={image} alt="dummy profile" />
      <div className="items-overflow">
        <div className="like ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="20"
            fill="none"
            viewBox="0 0 19 20"
          >
            <path
              stroke="#FBFBFB"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M9.3 17.378a29.033 29.033 0 0 1-5.017-3.907 9.992 9.992 0 0 1-2.389-3.808c-.896-2.788.151-5.979 3.082-6.923a4.982 4.982 0 0 1 4.52.761 4.99 4.99 0 0 1 4.522-.761c2.93.944 3.985 4.135 3.089 6.923a9.991 9.991 0 0 1-2.389 3.808A29.03 29.03 0 0 1 9.7 17.378l-.196.122-.203-.122Z"
              clip-rule="evenodd"
            />
            <path
              stroke="#FBFBFB"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M12.616 5.877a2.318 2.318 0 0 1 1.597 2.019"
              opacity=".4"
            />
          </svg>
          <span>{likes}</span>
        </div>
        <div className="comment">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="20"
            fill="none"
            viewBox="0 0 19 20"
          >
            <path
              stroke="#FBFBFB"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M9.545 2.084a7.932 7.932 0 0 0-6.805 3.8 7.906 7.906 0 0 0-.256 7.78l.159.31c.13.243.157.528.075.791a15.68 15.68 0 0 0-.566 1.84c0 .317.09.498.43.49a14.448 14.448 0 0 0 1.775-.513c.25-.068.515-.053.755.046.219.105.665.377.68.377a7.94 7.94 0 0 0 8.933-1.061 7.908 7.908 0 0 0 2.191-8.711 7.93 7.93 0 0 0-7.371-5.15v0Z"
              clip-rule="evenodd"
            />
            <ellipse
              cx="5.769"
              cy="10"
              fill="#FBFBFB"
              stroke="#FBFBFB"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              opacity=".4"
              rx=".378"
              ry=".377"
            />
            <ellipse
              cx="9.545"
              cy="10"
              fill="#FBFBFB"
              stroke="#FBFBFB"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              opacity=".4"
              rx=".378"
              ry=".377"
            />
            <ellipse
              cx="13.321"
              cy="10"
              fill="#FBFBFB"
              stroke="#FBFBFB"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              opacity=".4"
              rx=".378"
              ry=".377"
            />
          </svg>

          <span>{comment}</span>
        </div>
      </div>
    </div>
  );
};

export default Card;
